import React, { Component } from "react";

class Footer extends Component {

    render() {
        return(
            <React.Fragment>
                      <footer>
                        <div class="container">
                            <div class="row">
                            <div class="col-12 col-lg-3 footer-content">
                                <img src={"../assets/img/logo.png"} class="footer-logo" alt="Logo da ITechMed"></img>
                                <ul>
                                <li><a href="/quem-somos">Quem Somos</a></li>
                                <li><a href="/contato">Contato</a></li>
                                <li><a href="/privacidade">Privacidade LGPD</a></li>
                                <li><a href="/compliance">Compliance</a></li>
                                {/* <!-- <li><a href="conteudo.php?p=politica-de-privacidade">Política de Privacidade</a></li> --> */}
                                </ul>
                            </div>

                            <div class="col-12 col-lg-5 footer-content">
                                <ul class="menu-rodape">
                                <li class="especial">Nossas Soluções</li>
                                <li><a href="/temperatura">Monitoramento de Temperatura e Umidade</a></li>
                                <li><a href="/ativos">Rastreabilidade de Equipamentos</a></li>
                                <li><a href="/atendimento-de-check-up">Atendimento de Check-up</a></li>
                                <li><a href="/leitos-e-centros-cirurgicos">Gestão de Ocupação de Leitos e Centros cirúrgicos</a></li>
                                <li><a href="/limpeza">Gestão de Processo de Limpeza</a></li>
                                <li><a href="/rfid">Soluções RFID</a></li>
                                <li><a href="/atendimento-clinicas">Atendimento em Clínicas Radiológicas</a></li>
                                </ul>

                            </div>

                            <div class="col-12 col-lg-4 footer-content">
                                <ul>
                                <li>
                                    <a href="tel:1150712286" class="redes">
                                    <img src={"../assets/img/ico-telefone.svg"} alt="Icone Telefone"></img>
                                    <p>+55 11 <b>5071-2286</b></p>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://wa.me/5511956297239?text=Olá,%20acessei%20o%20site%20e%20estou%20entrando%20em%20contato." class="redes">
                                    <img src={"../assets/img/ico-whatsapp.svg"} alt="Icone Whatsapp"></img>
                                    <p>11 <b>9.5629-7239</b></p>
                                    </a>
                                </li>
                                
                                <li>
                                    <a href="https://www.linkedin.com/company/itech-med-tecnologia-em-saude/" target="_blank" class="redes">
                                    <img src={"../assets/img/ico-linkedin.svg"} alt="Icone Linkedin"></img>
                                    <p>linkedin.com/itechmed</p>
                                    </a>
                                </li>
                                
                                <li>
                                    <a href="mailto:comercial@itechmed.com.br" class="redes">
                                    <img src={"../assets/img/ico-email.svg"} alt="Icone Email"></img>
                                    <p>comercial@itechmed.com.br</p>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://goo.gl/maps/7LGHDRrXeuzHrbVV6" target="_blank" class="redes">
                                    <img src={"../assets/img/ico-endereco.svg"} alt="Icone Endereço"></img>
                                    <p>Rua Carneiro da Cunha, 167 – 10º Andar, CJ 109 – Saúde – SP/04144-910</p>
                                    </a>
                                </li>
                                </ul>
                            </div>
                            </div>
                        </div>

                        <div class="copyright">
                            <p>COPYRIGHT © 2022 | ITECHMED | TODOS OS DIREITOS RESERVADOS | <a href="https://www.elogos.com.br" target="_blanck">ELOGOS AGÊNCIA DIGITAL</a></p>
                        </div>
                        </footer>
            </React.Fragment>
        );
    }
}

export default Footer;